module.exports = __webpack_public_path__ + "static/img/reward_banner.3b1ab07c.png";